import { computedFrom } from "aurelia-framework";
import { Reflection } from "../../helpers/reflection";

export interface IPaginationPage
{
	currentPage: number;
	lastPage: number;
	nextClick?(): void;
	previousClick?(): void;
}

export abstract class PaginationMappings<T extends IPaginationPage> {

	public abstract get currentPage(): number;
	public abstract set currentPage(page: number);
	public abstract get lastPage(): number;

	public constructor(protected source: T) {  }

	public abstract next(): void;
	public abstract previous(): void;
}

export class PagePaginationMappings extends PaginationMappings<IPaginationPage> {

	public get currentPage(): number {
		return this.source.currentPage;
	}

	public set currentPage(page: number) {
		this.source.currentPage = page;
	}

	@computedFrom(Reflection.getPropertyPath<PagePaginationMappings>(z => z.source.lastPage))
	public get lastPage(): number {
		return this.source.lastPage;
	}

	public next(): void {
		this.source.nextClick();
	}

	public previous(): void {
		this.source.previousClick();
	}
}